import classes from "./Button.module.css";

const Button = (props) => {
  return (
    <button className={`${classes["button-as-link"]}`} {...props}>
      {props.children}
    </button>
  );
};

export default Button;
